export enum FileState{
    CANCELED = 1,
    NOT_PROCESSED = 2,
    PROCESSED = 3,
    NEW = 4,
    NOT_RELEVANT = 5
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/file/file.state.ts